(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    // CREAMETAL-Anpassung: Klick auf die eigene Sprachliste in das ausgeblendete
  // <select> schreiben und ein change-Ereignis auslösen. Damit übernimmt Horizons
  // eigene /changeLanguage-Logik den Rest — wir bauen die Umschaltung nicht nach.
  // Delegiert am Dokument, weil die Liste in Kopfzeile und Menü-Schublade doppelt
  // vorkommt und beim Öffnen der Schublade neu gezeichnet werden kann.
  document.addEventListener('click', (event) => {
    const item = event.target.closest('[data-cm-language-list] > li');
    if (!item) return;
    const select = item.closest('form')?.querySelector('select[name="language_code"]');
    if (!select || select.value === item.dataset.value) return;
    select.value = item.dataset.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Tastaturbedienung: Enter und Leertaste verhalten sich wie ein Klick.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const item = event.target.closest?.('[data-cm-language-list] > li');
    if (!item) return;
    event.preventDefault();
    item.click();
  });
  } catch(e) { console.error(e); }
})();

})();
